<template>
  <svg id="deur" viewBox="355 100 45 48">
    <path
      d="M389.523,140.223h-23.615v-39.79h23.615V140.223z M367.109,139.023h21.215v-37.39h-21.215V139.023z"
    />
    <polygon
      points="387.303,139.717 386.103,139.717 386.103,103.945 369.331,103.945 369.331,139.717 368.13,139.717 368.13,102.745
	387.303,102.745 "
    />
    <path
      d="M390.963,146.038h-26.494v-4.202h26.494V146.038z M365.67,144.838h24.094v-1.802H365.67V144.838z"
    />
    <path
      d="M389.519,142.811h-23.604v-3.788h23.604V142.811z M367.115,141.611h21.204v-1.388h-21.204V141.611z"
    />
    <path
      d="M381.013,117.527h-6.592v-9.623h6.592V117.527z M375.62,116.327h4.192v-7.223h-4.192V116.327z"
    />
    <g>
      <path
        d="M383.436,127.116l-2.517-0.003c-0.913,0-1.656-0.743-1.656-1.657c0-0.442,0.173-0.858,0.485-1.172
		c0.31-0.309,0.735-0.484,1.168-0.484l2.521,0.001c0.915,0.003,1.658,0.745,1.658,1.657c-0.002,0.444-0.174,0.861-0.486,1.172
		C384.293,126.943,383.878,127.116,383.436,127.116 M380.919,125c-0.122,0-0.239,0.049-0.324,0.133
		c-0.085,0.087-0.133,0.201-0.133,0.323c0,0.252,0.205,0.457,0.456,0.457l2.517,0.003c0.123,0,0.237-0.048,0.323-0.135
		c0.087-0.086,0.135-0.201,0.135-0.324c0-0.251-0.206-0.456-0.459-0.456L380.919,125z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconDeur extends Vue {}
</script>
